import { PropsWithChildren, useMemo } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { globalStyles } from '@/styled';
import { createAppTheme } from '@/theme';

import useThemeMode from './useThemeMode';

function ThemeModeProvider({ children }: PropsWithChildren<{}>) {
  const { resolvedMode } = useThemeMode();
  const theme = useMemo(() => createAppTheme(resolvedMode), [resolvedMode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      {children}
    </MuiThemeProvider>
  );
}

export default ThemeModeProvider;
